// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    people: {
      label: 'Plantilla',
      help: 'Una fila por persona del expediente. No lleva ninguna retribución y no puede llevarla',
    },
    documents: {
      label: 'Documentos de personal',
      help: 'Una fila por documento del expediente: carnés, certificados, reconocimientos',
    },
    dates: {
      hired: 'Fecha de alta',
      ended: 'Fecha de baja',
      validUntil: 'Caduca el',
      issued: 'Fecha de expedición',
      validFrom: 'Válido desde',
    },
    metrics: {
      people: 'Fichas',
      active: 'En plantilla',
      leavers: 'Bajas',
      weeklyHours: 'Horas semanales contratadas',
      averageHours: 'Jornada media semanal',
      tenure: 'Antigüedad media',
      turnover: 'Rotación',
      documents: 'Documentos',
      expired: 'Caducados',
      pendingDocs: 'Pendientes de validar',
      valid: 'En regla',
      versions: 'Versiones subidas',
      validRate: 'Documentación en regla',
    },
    dimensions: {
      department: 'Departamento',
      position: 'Puesto',
      category: 'Categoría',
      site: 'Centro',
      manager: 'Responsable',
      status: 'Estado',
      docType: 'Tipo de documento',
      state: 'Estado del documento',
      person: 'Persona',
    },
    filters: {
      hours: 'Horas semanales',
    },
  },
  ca: {
    people: {
      label: 'Plantilla',
      help: 'Una fila per persona de l\'expedient. No porta cap retribució i no en pot portar',
    },
    documents: {
      label: 'Documents de personal',
      help: 'Una fila per document de l\'expedient: carnets, certificats, reconeixements',
    },
    dates: {
      hired: 'Data d\'alta',
      ended: 'Data de baixa',
      validUntil: 'Caduca el',
      issued: 'Data d\'expedició',
      validFrom: 'Vàlid des de',
    },
    metrics: {
      people: 'Fitxes',
      active: 'En plantilla',
      leavers: 'Baixes',
      weeklyHours: 'Hores setmanals contractades',
      averageHours: 'Jornada mitjana setmanal',
      tenure: 'Antiguitat mitjana',
      turnover: 'Rotació',
      documents: 'Documents',
      expired: 'Caducats',
      pendingDocs: 'Pendents de validar',
      valid: 'En regla',
      versions: 'Versions pujades',
      validRate: 'Documentació en regla',
    },
    dimensions: {
      department: 'Departament',
      position: 'Lloc',
      category: 'Categoria',
      site: 'Centre',
      manager: 'Responsable',
      status: 'Estat',
      docType: 'Tipus de document',
      state: 'Estat del document',
      person: 'Persona',
    },
    filters: {
      hours: 'Hores setmanals',
    },
  },
  en: {
    people: {
      label: 'Staff',
      help: 'One row per person on the staff file. It carries no pay and cannot be made to',
    },
    documents: {
      label: 'Staff documents',
      help: 'One row per document on a staff file: licences, certificates, clearances',
    },
    dates: {
      hired: 'Hired on',
      ended: 'Left on',
      validUntil: 'Valid until',
      issued: 'Issued on',
      validFrom: 'Valid from',
    },
    metrics: {
      people: 'Records',
      active: 'Employed',
      leavers: 'Leavers',
      weeklyHours: 'Contracted weekly hours',
      averageHours: 'Average weekly hours',
      tenure: 'Average tenure',
      turnover: 'Turnover',
      documents: 'Documents',
      expired: 'Expired',
      pendingDocs: 'Awaiting validation',
      valid: 'In order',
      versions: 'Versions uploaded',
      validRate: 'Documents in order',
    },
    dimensions: {
      department: 'Department',
      position: 'Position',
      category: 'Category',
      site: 'Site',
      manager: 'Manager',
      status: 'Status',
      docType: 'Document kind',
      state: 'Document state',
      person: 'Person',
    },
    filters: {
      hours: 'Weekly hours',
    },
  },
  fr: {
    people: {
      label: 'Effectif',
      help: 'Une ligne par personne du dossier. Sans rémunération, et impossible d\'en ajouter',
    },
    documents: {
      label: 'Documents du personnel',
      help: 'Une ligne par document du dossier : permis, certificats, aptitudes',
    },
    dates: {
      hired: 'Date d\'embauche',
      ended: 'Date de départ',
      validUntil: 'Expire le',
      issued: 'Date de délivrance',
      validFrom: 'Valable à partir du',
    },
    metrics: {
      people: 'Fiches',
      active: 'En poste',
      leavers: 'Départs',
      weeklyHours: 'Heures hebdomadaires contractuelles',
      averageHours: 'Durée hebdomadaire moyenne',
      tenure: 'Ancienneté moyenne',
      turnover: 'Rotation',
      documents: 'Documents',
      expired: 'Périmés',
      pendingDocs: 'En attente de validation',
      valid: 'En règle',
      versions: 'Versions déposées',
      validRate: 'Documents en règle',
    },
    dimensions: {
      department: 'Service',
      position: 'Poste',
      category: 'Catégorie',
      site: 'Site',
      manager: 'Responsable',
      status: 'Statut',
      docType: 'Type de document',
      state: 'État du document',
      person: 'Personne',
    },
    filters: {
      hours: 'Heures hebdomadaires',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
